import { useEffect, useRef } from "react";

function AdUnit({ slot, style }) {
  const adRef = useRef(null);

  useEffect(() => {
    const isPrerender =
      navigator.userAgent === "ReactSnap" ||
      window.__PRERENDER_INJECTED ||
      window.location.hostname === "localhost";

    if (isPrerender) return;

    let retryId;

    const tryPushAd = () => {
      const el = adRef.current;
      if (!el) return;

      if (el.getAttribute("data-adsbygoogle-status") === "done") return;

      const rect = el.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) {
        retryId = window.setTimeout(tryPushAd, 500);
        return;
      }

      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error("adsense push error", e);
      }
    };

    retryId = window.setTimeout(tryPushAd, 300);

    return () => {
      if (retryId) window.clearTimeout(retryId);
    };
  }, []);

  return (
    <ins
      ref={adRef}
      className="adsbygoogle"
      style={{ display: "block", width: "100%", minHeight: "100px", ...style }}
      data-ad-client="ca-pub-9376539204632687"
      data-ad-slot={slot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
}

function AdUnitMultiplex({ slot, style }) {
  const adRef = useRef(null);

  useEffect(() => {
    const isPrerender =
      navigator.userAgent === "ReactSnap" ||
      window.__PRERENDER_INJECTED ||
      window.location.hostname === "localhost";

    if (isPrerender) return;

    let retryId;

    const tryPushAd = () => {
      const el = adRef.current;
      if (!el) return;

      if (el.getAttribute("data-adsbygoogle-status") === "done") return;

      const rect = el.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) {
        retryId = window.setTimeout(tryPushAd, 500);
        return;
      }

      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error("adsense push error", e);
      }
    };

    retryId = window.setTimeout(tryPushAd, 300);

    return () => {
      if (retryId) window.clearTimeout(retryId);
    };
  }, []);

  return (
    <ins
      ref={adRef}
      className="adsbygoogle"
      style={{ display: "block", width: "100%", minHeight: "300px", ...style }}
      data-ad-client="ca-pub-9376539204632687"
      data-ad-slot={slot}
      data-ad-format="auto"
      data-matched-content-rows-num="4"
      data-matched-content-columns-num="1"
      data-matched-content-ui-type="image_card_sidebyside"
      data-full-width-responsive="true"
    />
  );

}

export { AdUnit, AdUnitMultiplex };